/**
 * This view prevents a logged-in user from navigating to routes like sign-in and sign-up.
 * Since it functions somewhat opposite to that of the protected-route,
 * it is named anti-protected-route
 */

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AuthManager from '../../../store/auth-manager';
import { updateRedirectTo } from '../../../app-root/reducers/routing-reducer';
import RouteUrls from '../../../constants/route-urls';

const AntiProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = AuthManager.isAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(updateRedirectTo(RouteUrls.fallbackForAuthenticated));
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return children;
  }
  return null;
};

AntiProtectedRoute.propTypes = {
  children: PropTypes.element,
};

AntiProtectedRoute.defaultProps = {
  children: null,
};

export {
  AntiProtectedRoute as default,
};
